import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "services-page" }
const _hoisted_2 = { class: "page-header" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = { class: "actions" }
const _hoisted_5 = { class: "content" }
const _hoisted_6 = { class: "content-actions" }

import { computed, onMounted, ref } from "vue";
import { useI18n } from "vue-i18n";
import { useRouter, useRoute } from "vue-router";
import store from "@/store";

import { toast } from "@/common/utils/toast";

import {
  categoryGet,
  categoryPatch,
  categoryDel,
} from "@/common/api/rest/category";

import type { CategoryType } from "@/common/types/category";
import type { TranslationFieldsType } from "@/common/types/translation";

import { PanelTheme } from "@/common/themes";
import { FormCategory, ListTranslate } from "@/components";
import {
  baseAvatar,
  baseConfirm,
  baseModal,
  tabMenu,
  svgIcon,
} from "@/common/components";


export default /*@__PURE__*/_defineComponent({
  __name: 'edit',
  setup(__props) {

const { t, locale } = useI18n();
const router = useRouter();
const route = useRoute();

const categoryData = ref<CategoryType | null>(null);

const payloadValid = ref(false);
const showModalDel = ref(false);

const translationFields = ref<TranslationFieldsType[]>([
  {
    type: "input",
    field: "name",
    value: "",
  },
  {
    type: "textarea",
    field: "description",
    value: "",
  },
]);

const categoryId = computed(() => route.params.category as string);

const listTabs = computed(() => [
  {
    key: "home",
    icon: "category",
    label: t("category.labels.category"),
    url: `/services/${categoryId.value}/edit`,
  },
  {
    key: "services",
    icon: "services",
    label: t("common.labels.items"),
    url: `/services/${categoryId.value}/items`,
  },
]);

function fetchData() {
  categoryGet(categoryId.value)
    .then((response) => {
      const { success, data, message } = response;

      if (success) {
        categoryData.value = data;
      } else {
        toast({ message: message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    });
}

function patchData(payload: Partial<CategoryType>) {
  categoryPatch(categoryId.value, payload)
    .then((response) => {
      const { success, message } = response;

      if (success) {
        fetchData();
        toast({ message: message, type: "success" });
      } else {
        toast({ message: message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    });
}

function delCategory() {
  showModalDel.value = true;
}

function delCategoryCancel() {
  showModalDel.value = false;
}

function delCategoryConfirm() {
  categoryDel(categoryId.value)
    .then((response) => {
      const { success, message } = response;

      if (success) {
        back();
        toast({ message: message, type: "success" });
      } else {
        toast({ message: message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    });
}

function back() {
  router.push(`/services`);
}

onMounted(() => {
  fetchData();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("article", _hoisted_1, [
    _createVNode(_unref(PanelTheme), null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_unref(svgIcon), {
              icon: "services",
              size: "2rem"
            }),
            _createTextVNode(" " + _toDisplayString(_unref(t)("common.labels.services")) + " | " + _toDisplayString(_unref(t)("category.labels.category")), 1)
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("button", {
              class: "btn btn-md btn-default px-3",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (back()))
            }, [
              _createVNode(_unref(svgIcon), {
                icon: "close",
                size: "1.25rem"
              })
            ])
          ])
        ]),
        _createVNode(_unref(tabMenu), {
          tabs: listTabs.value,
          active: 'home',
          "padding-inline": "1.25rem"
        }, {
          content: _withCtx(() => [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("button", {
                  class: "btn btn-md btn-default",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (delCategory()))
                }, [
                  _createVNode(_unref(svgIcon), {
                    icon: "trash",
                    size: "1.25rem"
                  }),
                  _createTextVNode(" " + _toDisplayString(_unref(t)("category.labels.category").toUpperCase()), 1)
                ])
              ]),
              _createVNode(_unref(FormCategory), {
                type: "SERVICES",
                data: categoryData.value,
                "is-patch": true,
                "onUpdate:data": _cache[2] || (_cache[2] = ($event: any) => (patchData($event))),
                onValidate: _cache[3] || (_cache[3] = ($event: any) => (payloadValid.value = $event))
              }, null, 8, ["data"]),
              _createVNode(_unref(ListTranslate), {
                "owner-id": categoryId.value,
                language: _unref(locale).toLowerCase(),
                fields: translationFields.value
              }, null, 8, ["owner-id", "language", "fields"])
            ])
          ]),
          _: 1
        }, 8, ["tabs"])
      ]),
      _: 1
    }),
    _createVNode(_unref(baseConfirm), {
      show: showModalDel.value,
      title: _unref(t)('category.labels.delete_category').toUpperCase(),
      message: _unref(t)('category.texts.delete_category'),
      onCancel: _cache[4] || (_cache[4] = ($event: any) => (delCategoryCancel())),
      onConfirm: _cache[5] || (_cache[5] = ($event: any) => (delCategoryConfirm()))
    }, null, 8, ["show", "title", "message"])
  ]))
}
}

})